function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Eco = function Eco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#151518",
    fillRule: "evenodd",
    d: "m8.66 2.14-.435.61-.436-.61a.75.75 0 0 1 .871 0m4.98 6.17c-.747-1.768-1.886-3.228-2.87-4.27a18 18 0 0 0-1.468-1.392 14 14 0 0 0-.59-.47l-.036-.027-.01-.008-.004-.002s-.002-.001-.437.609l-.436-.61-.003.002-.005.003-.015.01a6 6 0 0 0-.24.184c-.16.125-.384.308-.653.545-.535.472-1.25 1.16-1.965 2.029C3.488 6.636 2 9.149 2 12.135s1.478 5.482 2.89 7.192c.71.86 1.42 1.542 1.952 2.008a15 15 0 0 0 .888.719l.015.01.004.004h.002s.001.002.434-.61l-.433.612a.75.75 0 0 0 .31.127l.123-.74-.123.74h.003l.006.002.018.003a6 6 0 0 0 .3.04 17.908 17.908 0 0 0 3.67.031c2.223-.215 5.052-.939 7.164-3.05 2.112-2.112 2.835-4.941 3.05-7.164.109-1.12.09-2.111.046-2.824a15 15 0 0 0-.117-1.146l-.003-.018v-.006l-.001-.002-.74.122.74-.123a.75.75 0 0 0-.617-.617l-.123.74.123-.74h-.006l-.013-.003-.045-.007-.163-.022c-.14-.018-.341-.041-.592-.062a18 18 0 0 0-2.04-.054c-1.443.045-3.294.276-5.081 1.013m.49 1.421a9.4 9.4 0 0 1 .32 2.404c0 .801-.109 1.567-.294 2.291l5.63-5.63a17 17 0 0 0-1.017 0c-1.367.043-3.056.266-4.64.935m-2.064 8.907a17 17 0 0 1-1.988 2.213c.535.01 1.162-.005 1.837-.07 2.064-.2 4.488-.86 6.247-2.619 1.76-1.76 2.419-4.184 2.618-6.247.075-.77.084-1.477.066-2.058zm-3.127 1.224a15.7 15.7 0 0 0 1.955-2.162c1.118-1.508 2.055-3.417 2.055-5.565 0-.902-.163-1.762-.436-2.572-.618-1.835-1.79-3.387-2.834-4.494a17 17 0 0 0-.708-.707zm-1.5-.01c-.419-.392-.906-.89-1.393-1.48C4.74 16.789 3.5 14.624 3.5 12.135s1.248-4.668 2.566-6.269c.491-.596.983-1.1 1.405-1.498z",
    clipRule: "evenodd"
  }));
};
export default Eco;
Eco.displayName = 'Eco';